import { render, staticRenderFns } from "./new-transfer-popup.vue?vue&type=template&id=1d983ff4&"
import script from "./new-transfer-popup.vue?vue&type=script&lang=js&"
export * from "./new-transfer-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports